import React from 'react';

import classes from './landing.css';

import Image from '../../assets/logo-color.png';

const Logo
 = () => (
     <div className={classes.installImages}>
         <img alt="Solvana - A digital proposal app powered by Solvana" src={Image} className={classes.installImg} />
     </div>
 );


export default Logo;



// WEBPACK FOOTER //
// ./src/containers/Landing/SolvanaLogo.js